import { render, staticRenderFns } from "./DepotPieces.vue?vue&type=template&id=297085ce"
import script from "./DepotPieces.vue?vue&type=script&lang=js"
export * from "./DepotPieces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports